import getColumnSizing, { fillLastColumn } from './getColumnSizing';

const mapColumns = (columnDefs) =>
  columnDefs?.map((column) => ({
    ...column,
    ...getColumnSizing(column),
    headerName: column.headerName ?? column.displayName,
    headerTooltip:
      column.headerTooltip ?? column.headerName ?? column.displayName,
    ...(column.children && { children: mapColumns(column.children) }),
  }));

const mapColumnHeaders = (columnDefs) => fillLastColumn(mapColumns(columnDefs));

export default mapColumnHeaders;
